import { render, staticRenderFns } from "./EVChart.vue?vue&type=template&id=1c053672&scoped=true&"
import script from "./EVChart.vue?vue&type=script&lang=js&"
export * from "./EVChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c053672",
  null
  
)

export default component.exports